import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';
import { userActions, uiActions } from '../actions';
import { history } from '../helpers';
import Strings from './../common/Strings';
import './SideMenu.css';
import Constant from '../common/Constant';

const MENU_ITEM_ACTIVITY = 0;
const MENU_ITEM_TIMER = 1;
const MENU_ITEM_HISTORY = 2;
const MENU_ITEM_PROJECTS = 3;
const MENU_ITEM_SETTINGS = 4;

const SideMenuAction = ({ id, active, src, label, showIndicator, onClick }) => {
  const className = active
    ? 'side-menu-container active'
    : 'side-menu-container';
  let indicator;
  if (showIndicator) {
    indicator = <div className="side-menu-indicator" />;
  }
  return (
    <div className="side-menu-container-root">
      <button id={id} className={className} onClick={onClick}>
        <div className="side-menu-img-container">
          <img className="side-menu-img" src={src} alt="" />
        </div>
        <p className="side-menu-text">{label}</p>
      </button>
      {indicator}
    </div>
  );
};

SideMenuAction.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  showIndicator: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SideMenuAction.defaultProps = {
  showIndicator: false,
};

class SideMenu extends React.Component {
  logOut = () => {
    const { dispatch } = this.props;
    dispatch(userActions.signOut());
  };

  menuItemClick = (index, path) => {
    const { dispatch } = this.props;
    dispatch(uiActions.menuItemClicked(index));
    history.replace(path);
  };

  render() {
    return (
      <div className="side-menu-root">
        <p id="user-name-text" className="side-menu-name">
          {this.props.displayName}
        </p>
        <p id="user-email-text" className="side-menu-email">
          {this.props.email}
        </p>
        <SideMenuAction
          id="activity-menu-item"
          active={this.props.activeMenuItem === MENU_ITEM_ACTIVITY}
          src="/icon/activity.svg"
          label={Strings.DASHBOARD.activity}
          onClick={() => this.menuItemClick(MENU_ITEM_ACTIVITY, '/activity')}
        />
        <SideMenuAction
          id="activity-menu-item"
          active={this.props.activeMenuItem === MENU_ITEM_TIMER}
          src="/icon/timer.svg"
          label={Strings.DASHBOARD.timer}
          showIndicator={this.props.timer.status !== Constant.TIMER_NOT_RUNNING}
          onClick={() => this.menuItemClick(MENU_ITEM_TIMER, '/timer')}
        />
        <SideMenuAction
          id="history-menu-item"
          active={this.props.activeMenuItem === MENU_ITEM_HISTORY}
          src="/icon/history.svg"
          label={Strings.DASHBOARD.history}
          onClick={() => this.menuItemClick(MENU_ITEM_HISTORY, '/history')}
        />
        <SideMenuAction
          id="projects-menu-item"
          active={this.props.activeMenuItem === MENU_ITEM_PROJECTS}
          src="/icon/projects.svg"
          label={Strings.DASHBOARD.projects}
          onClick={() => this.menuItemClick(MENU_ITEM_PROJECTS, '/projects')}
        />
        <SideMenuAction
          id="settings-menu-item"
          active={this.props.activeMenuItem === MENU_ITEM_SETTINGS}
          src="/icon/settings.svg"
          label={Strings.DASHBOARD.settings}
          onClick={() => this.menuItemClick(MENU_ITEM_SETTINGS, '/settings')}
        />
        <div className="side-menu-line" />
        <button
          id="log-out-button"
          className="side-menu-log-out"
          onClick={this.logOut}
        >
          {Strings.DASHBOARD.logOut}
        </button>
        <div className="side-menu-space" />
        <Image
          id="app-logo"
          className="side-menu-bottom-img"
          src="/logo-app.png"
        />
      </div>
    );
  }
}

SideMenu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  activeMenuItem: PropTypes.number,
  displayName: PropTypes.string,
  email: PropTypes.string,
  timer: PropTypes.shape({
    status: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    startAtMillis: PropTypes.number.isRequired,
    millisRecorded: PropTypes.number.isRequired,
  }).isRequired,
};

SideMenu.defaultProps = {
  activeMenuItem: 0,
  displayName: '',
  email: '',
};

const mapStateToProps = state => ({
  activeMenuItem: state.uiState.activeMenuItem,
  displayName: state.user.displayName,
  email: state.user.email,
  timer: state.user.timer,
});

export default connect(mapStateToProps)(SideMenu);



// WEBPACK FOOTER //
// ./src/components/SideMenu.js